module.exports = __webpack_public_path__ + "static/media/frame_33.0e117638.jpg";